import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Layout } from "antd";

import { BackButton } from "../../uiMerge/backButton";

// import * as ROUTES from "../../constants/routes";
// let { Header } = Layout;

interface Props {
  // navMenu: any;
  // currentPage: number;
  pageTitle: string;
  bgImg?: string;
  icon?: React.ReactNode;
}

// class C extends React.PureComponent<Props> {
const C: React.FC<Props> = ({ pageTitle, bgImg, icon }) => {
  useEffect(() => {
    document.title = pageTitle;
    return () => {
      document.title = "Njoy"; // or your default
    };
  }, [pageTitle]);

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/"; // fallback to home if no history
    }
  };

  return (
    <div
    className="h-40 flex-shrink-0 z-1 w-full shadow-md bg-cover bg-center relative"
    style={{ backgroundImage: `url(${bgImg})` }}>
      <div className="absolute inset-0 bg-black opacity-40" />

      <div className="flex z-[9999] absolute inset-x-0 items-start justify-between py-4 px-[1rem] mt-4">
        <BackButton onClick={handleBack} />
        {icon ? (
          <div className="w-[40px] h-[40px] flex justify-center items-center">
            {icon}
          </div>
        ) : (
          <div className="w-[44px] h-[44px]" />
        )}
      </div>
    </div>
  );
};

export const HeaderSub = C;
